module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/og_page2-A.22023181.jpg";